// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-box {
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  padding: 3em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.warning-icon {
  font-size: 60px;
  text-align: center;
  color: #f35870;
}

.warning-text {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
}

@media (max-width: 600px) {
  .column-box {
    width: 80%;
  }
  .warning-text {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
